import React, { Component } from 'react';
import PropTypes from 'prop-types';

const withFollowList = (EnhancedComponent) =>
    class WithFollowListWrapper extends Component {
        static contextTypes = {
            subscribeToContextUpdates: PropTypes.func,
            unsubscribeFromContextUpdates: PropTypes.func,

            onFollow: PropTypes.func,
            onUnFollow: PropTypes.func,
            onRemoveOrganizer: PropTypes.func,
            onViewOrganizer: PropTypes.func,
        };

        state = {
            organizers: [],
            organizerData: {},
        };

        componentDidMount() {
            const { subscribeToContextUpdates } = this.context;

            if (subscribeToContextUpdates) {
                subscribeToContextUpdates(this._updateState);
            }
        }

        componentWillUnmount() {
            const { unsubscribeFromContextUpdates } = this.context;

            if (unsubscribeFromContextUpdates) {
                unsubscribeFromContextUpdates(this._updateState);
            }
        }

        _updateState = (followState) => {
            this.setState(followState);
        };

        _handleFollow = (organizerId, callback) => {
            this.context.onFollow(organizerId, callback);
        };

        _handleUnFollow = (organizerId, callback) => {
            this.context.onUnFollow(organizerId, callback);
        };

        _handleRemoveOrganizer = (organizerId) => {
            this.context.onRemoveOrganizer(organizerId);
        };

        _handleViewOrganizer = (organizerId) => {
            this.context.onViewOrganizer(organizerId);
        };

        render() {
            return (
                <EnhancedComponent
                    {...this.props}
                    onFollow={this._handleFollow}
                    onUnFollow={this._handleUnFollow}
                    onRemoveOrganizer={this._handleRemoveOrganizer}
                    onViewOrganizer={this._handleViewOrganizer}
                    organizers={this.state.organizers}
                    organizerData={this.state.organizerData}
                />
            );
        }
    };

export default withFollowList;
